import * as React from 'react';

import { IContentfulImageBlock } from '../../../utils/fragments/ImageBlockFragment';
import { useTranslate } from '@sorpetaler/ui/src/utils/translation/useTranslation';
import * as styles from '../DoorWidget.module.less';
import { OptionTileContainer } from '../OptionTileContainer/OptionTileContainer';

interface IConstructionProjectProps {
  onSelect: (element: string) => void;
  selectedItem: string;
  block?: IContentfulImageBlock;
}

export const ConstructionProject: React.FunctionComponent<IConstructionProjectProps> = ({
  onSelect,
  selectedItem,
  block,
}) => {
  const { t } = useTranslate();

  return (
    <div className={styles.step1Container}>
      <div className={styles.headlineRow}>
        <div className={styles.containerWrapper}>
          <h2 className={styles.headline}>{t('constructionProjectQuestion')}</h2>
          <div className={styles.helperText}>{t('selectOption')}</div>
        </div>
      </div>
      <OptionTileContainer
        images={block?.images || []}
        selectedItems={[selectedItem]}
        onSelect={onSelect}
        centered
        step={1}
      />
    </div>
  );
};
